<template>
  <div>
    <div>
      <h3 class="page-title text-center">{{ title }}</h3>
      <dashboard-list-box :rows="rows" :columns="columns"></dashboard-list-box>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import router from '@/router';
import DashboardListBox from '@/components/PettyCash/Certificate/DashboardListBox.vue';

export default {
  name: 'DashboardList',
  components: {
    DashboardListBox
  },
  data() {
    return {
      columns: [
        { id: 'index', headerText: 'S.NO.', textKey: 'index', width: '4%' },
        { id: 'company', headerText: 'Company', textKey: 'company', width: '6%' },
        { id: 'storeid', headerText: 'Store Code', textKey: 'storeid', width: '4%' },
        { id: 'storeName', headerText: 'Store Name', textKey: 'storeName', width: '14%' },
        {
          id: 'mainCashSystemBalance',
          headerText: 'Main Cash System Balance',
          textKey: 'mainCashSystemBalance',
          width: '9%'
        },
        {
          id: 'mainCashPhysicalBalance',
          headerText: 'Main Cash Physical Balance',
          textKey: 'mainCashPhysicalBalance',
          width: '9%'
        },
        { id: 'onlineCashBalance', headerText: 'Online Cash', textKey: 'onlineCashBalance', width: '6%' },
        {
          id: 'floatCashSystemBalance',
          headerText: 'Float Cash System Balance',
          textKey: 'floatCashSystemBalance',
          width: '9%'
        },
        {
          id: 'floatCashPhysicalBalance',
          headerText: 'Float Cash Physical Balance',
          textKey: 'floatCashPhysicalBalance',
          width: '9%'
        },
        {
          id: 'pettyCashSystemBalance',
          headerText: 'Petty Cash System Balance',
          textKey: 'pettyCashSystemBalance',
          width: '9%'
        },
        {
          id: 'pettyCashPhysicalBalance',
          headerText: 'Petty Cash Physical Balance',
          textKey: 'pettyCashPhysicalBalance',
          width: '9%'
        },
        { id: 'remarks', headerText: 'Remark', textKey: 'remarks', width: '6%' },
        { id: 'status', headerText: 'Status', textKey: 'status', width: '6%' }
      ],
      rows: []
    };
  },
  mounted() {
    this.dashboardCertificateList({ query: {} });
  },
  computed: {
    ...mapState('pettyCash', ['dashboardList']),
    title() {
      return 'Dashboard Certificate List';
    }
  },
  methods: {
    ...mapActions('pettyCash', ['dashboardCertificateList'])
  },
  watch: {
    dashboardList(newValue) {
      if (newValue.length > 0) {
        this.rows = [...newValue];
      }
    }
  }
};
</script>
